import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "components/ui/card";
import { Button } from "components/ui/button";
import { Skeleton } from "components/ui/skeleton";
import { AlertCircle, RefreshCw, Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import LoginRequiredSection from "Explore/Components/LoginRequired";

const SectionCard = ({
  title,
  description,
  isLoading,
  error,
  isHidden, // for guest users (hidden_fields)
  isEmpty,
  onRetry,
  onSeeMore, // function to navigate or action
  seeMoreText = "See more",
  children,
  className = "",
  headerEnd, // optional element in header (e.g. toggle buttons)
}) => {
  return (
    <Card className={`flex flex-col h-full ${className}`}>
      <CardHeader className="flex flex-row items-center justify-between pb-4">
        <div className="space-y-1">
          <CardTitle className="text-xl font-bold">{title}</CardTitle>
          {description && <CardDescription>{description}</CardDescription>}
        </div>
        {headerEnd && <div>{headerEnd}</div>}
      </CardHeader>
      <CardContent className="flex-1 flex flex-col gap-4">
        {isHidden ? (
          <div className="flex-1 flex items-center justify-center min-h-[200px]">
            <LoginRequiredSection />
          </div>
        ) : isLoading ? (
          <div className="space-y-4 flex-1">
            <Skeleton className="h-20 w-full rounded-xl" />
            <Skeleton className="h-20 w-full rounded-xl" />
            <Skeleton className="h-20 w-full rounded-xl" />
          </div>
        ) : error ? (
          <div className="flex-1 flex flex-col items-center justify-center p-6 text-center bg-destructive/5 rounded-xl border border-destructive/20">
            <AlertCircle className="w-10 h-10 text-destructive mb-4" />
            <p className="text-destructive font-medium mb-2">Failed to load data</p>
            <p className="text-sm text-destructive/80 mb-4">{error}</p>
            {onRetry && (
              <Button variant="outline" size="sm" onClick={onRetry} className="gap-2">
                <RefreshCw className="w-4 h-4" />
                Retry
              </Button>
            )}
          </div>
        ) : isEmpty ? (
          <div className="flex-1 flex items-center justify-center p-6 text-center bg-muted/30 rounded-xl border border-border/50">
            <p className="text-muted-foreground">No data available for this section.</p>
          </div>
        ) : (
          <div className="flex-1 flex flex-col gap-4">
            {children}
            {onSeeMore && (
              <div className="mt-auto pt-4 flex justify-end">
                <Button variant="link" onClick={onSeeMore} className="text-explore px-0">
                  {seeMoreText} &rarr;
                </Button>
              </div>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default SectionCard;
